import React ,{ useState } from 'react';
import { producaov2 } from '../../../../services/apis';
import { Box, CircularProgress, IconButton } from '@material-ui/core';
import { Edit, RemoveCircleOutline } from '@material-ui/icons';
import { toast } from 'react-toastify';
import FeedbackSendOptionsModal from './FeedbackSendOptionsModal';

const validFeedbackFileExtensions = [
  '.pdf',
  '.xls',
  '.xlsx',
];

export default function FeedbackActions({ defaultFeedback, defaultFeedbackType, applicationPhaseID, applicationID, onSubmitFeedback = () => {}, onResetFeedback = () => {} }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [feedback, setFeedback] = useState(defaultFeedback);
  const [feedbackType, setFeedbackType] = useState(defaultFeedbackType);
  const [loadingResetFeedback, setLoadingResetFeedback] = useState(false);

  const toggleModalVisibility = () => {
    setModalVisible(prev => !prev);
  }

  const handleFeedbackSubmit = ({ feedback, type }) => {
    setFeedback(feedback);
    setFeedbackType(type);
    setModalVisible(false);

    onSubmitFeedback();
  }

  const handleResetFeedback = async () => {
    setLoadingResetFeedback(true);

    try {
      const response = await producaov2.delete(`/admin/project-applications/${applicationID}/phases/${applicationPhaseID}/feedback`);

      setFeedback("");
      setFeedbackType("file");

      onResetFeedback();

      toast.success("Feedback resetado com sucesso");
    } catch(error) {
      toast.error("Houve um erro ao resetar um feedback")
    } finally {
      setLoadingResetFeedback(false);
    }
  }

  return (
    <Box>
      <IconButton title="Editar feedback" size="small" onClick={toggleModalVisibility}>
        <Edit />
      </IconButton>
      {feedback && (
        <IconButton title="Resetar feedback" size="small" disabled={loadingResetFeedback} onClick={handleResetFeedback}>
          {loadingResetFeedback ? <CircularProgress size={14} /> : <RemoveCircleOutline color="error" />}
        </IconButton>
      )}
      <FeedbackSendOptionsModal
        key={`${modalVisible}-${feedback}-${feedbackType}`}
        open={modalVisible}
        applicationID={applicationID}
        applicationPhaseID={applicationPhaseID}
        onSubmit={handleFeedbackSubmit}
        onClose={toggleModalVisibility}
        defaultFeedback={feedback}
        feedbackType={feedbackType}
      />
    </Box>
  )
}